import { createContext } from "react";

export const associateContext = createContext();
export const officesContext = createContext();
export const associatesContext = createContext({});
export const loadingContext = createContext();
export const updateAssociatesContext = createContext();
export const departmentsContext = createContext();
export const SignUpContext = createContext();
export const updatedAssociateContext = createContext();
export const resultsPerPageContext = createContext();
export const tasksToApproveContext = createContext();
export const thanksCommentsContext = createContext();
export const notificationsContext = createContext();
//export const totalAssociatesContext = createContext();